(ns hypnos.dme.bar.title
  "The title bar."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:const true :private true} panels
  {:dashboard-panel {:label :ui.label/home
                     :link  "/dashboard"}
   :iris-panel      {:label :ui.label/iris
                     :link  "/iris"}
   :patients-panel  {:label :ui.label/patients
                     :link  "/patients"}
   :patient-panel   {:label :ui.label/patient
                     :link  "/patient"}
   :referral-panel  {:label :ui.label/referral
                     :link  "/referral"}})

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bar

(defn bar
  "The title bar"
  []
  (let [organization (rf/subscribe [:dme/organization])
        patient      (rf/subscribe [:dme/patient])
        panel        (rf/subscribe [:dme/active-panel])]
    [:section.section.is-title-bar
     [:div.level
      [:div.level-left
       [:div.level-item
        [:ul
         [:li [:a {:href (:link (panels (:name @panel)))} (tr (:label (panels (:name @panel))))]]
         ;; panel name
         (if @patient
           (for [item [(get-in @patient [:patient/organization :organization/key])
                       (or (:patient/key @patient) (:patient/id @patient))]]
             ^{:key item} [:li item])
           (when-let [org-key (:organization/key @organization)]
             [:li org-key]))]]]]]))
